import { Text, Badge, Group, Title, Table, ActionIcon, Tooltip } from '@mantine/core';
import { ViewPanel } from '@ayocore/platform/client/components/EntityViewLayout';
import { IconBriefcase, IconEye } from '@tabler/icons-react';
import { useNavigate } from 'react-router';
import type { PartnerDeal } from '../PartnerViewController';

type DealExtended = PartnerDeal & {
  deal_status?: { id?: number; name?: string; color?: string | null } | null;
};

interface PartnerDealsProps {
  deals: DealExtended[];
}

export function PartnerDeals({ deals }: PartnerDealsProps) {
  const navigate = useNavigate();

  return (
    <ViewPanel>
      <Group justify='space-between' align='center' mb='xs'>
        <Title order={4} style={{ fontSize: 14, fontWeight: 400 }}>
          <Group gap='sm'>
            <IconBriefcase size={16} />
            Последние сделки ({deals.length})
          </Group>
        </Title>
      </Group>

      {deals.length > 0 ? (
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>
                <Text size='xs'>Название</Text>
              </Table.Th>
              <Table.Th>
                <Text size='xs'>Сумма</Text>
              </Table.Th>
              <Table.Th>
                <Text size='xs'>Статус</Text>
              </Table.Th>
              <Table.Th>
                <Text size='xs'>Дата сделки</Text>
              </Table.Th>
              <Table.Th>
                <Text size='xs'>Действия</Text>
              </Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {deals.map(deal => (
              <Table.Tr key={deal.id}>
                <Table.Td>
                  <Text
                    fw={500}
                    size='xs'
                    style={{ cursor: 'pointer', textDecoration: 'underline' }}
                    onClick={() => navigate(`/crm/deals/${deal.id}`)}
                  >
                    Сделка {deal.number ?? `#${deal.id}`}
                  </Text>
                </Table.Td>
                <Table.Td>
                  <Text size='xs'>
                    {deal.amount ? `${Number(deal.amount).toLocaleString()} ₽` : '—'}
                  </Text>
                </Table.Td>
                <Table.Td>
                  {deal.deal_status?.name ? (
                    <Badge color={deal.deal_status.color || 'gray'} variant='light' size='xs'>
                      {deal.deal_status.name}
                    </Badge>
                  ) : (
                    <Text size='xs' c='dimmed'>
                      —
                    </Text>
                  )}
                </Table.Td>
                <Table.Td>
                  <Text size='xs'>
                    {deal.last_activity_date
                      ? new Date(deal.last_activity_date).toLocaleDateString('ru-RU')
                      : '—'}
                  </Text>
                </Table.Td>
                <Table.Td>
                  <Tooltip label='Просмотр сделки'>
                    <ActionIcon
                      variant='light'
                      size='xs'
                      onClick={() => navigate(`/crm/deals/${deal.id}`)}
                      style={{ cursor: 'pointer' }}
                    >
                      <IconEye size={14} />
                    </ActionIcon>
                  </Tooltip>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      ) : (
        <Text c='dimmed' ta='center' py='xs' size='xs'>
          Сделки для данного партнера не найдены
        </Text>
      )}
    </ViewPanel>
  );
}
